export default __webpack_public_path__ + "static/media/runningmanHeroV2-blue.77bb2280.jpg";